import Rails from '../src/js/vendor/ujs';
import { initToggleActive } from '../src/js/toggle-active';
import enableTippy from '../src/js/enable-tippy';
import selectAutoRedirect from '../src/js/select-auto-redirect';
import initCookieBanner from '../src/js/cookie-banner';

document.addEventListener('DOMContentLoaded', () => {
  Rails.start();
  initToggleActive();
  selectAutoRedirect();
  enableTippy();
  initCookieBanner();
});

// used when we load ember apps, to decrease the likelihood of version conflicts, e.g. multiple moment versions loaded at the same time
